import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MobileButtonService {

  // STATE
  public readonly active: WritableSignal<boolean> = signal(false);

  // METHODS
  public toggleButton(): void {
    this.active.update(x => !x);
  }

}
